/*
 * @Author: 欲买桂花同载酒，终不似，少年游。
 * @Date: 2025-11-06 11:38:17
 * @LastEditors: 欲买桂花同载酒，终不似，少年游。
 * @LastEditTime: 2025-11-06 11:38:26
 * @FilePath: \fly-web\src\utils\setRem.js
 * @filePurpose:
 */
(function (win, doc) {
  function change() {
    let clientWidth = doc.documentElement.clientWidth;
    if (clientWidth < 1360) {
      clientWidth = 1360;
    }
    doc.documentElement.style.fontSize = clientWidth / 19.2 + "px";
  }
  win.addEventListener("resize", change, false);
  change();
})(window, document);
